import { useGlobalContext } from "../context/useGlobalContext";
import { getMessageHost, sendMessageChat, markMessage, sendGlobalMessageChat } from "../services/chatService"
import { useProfile } from "./useTypeProfile";
import { useWebSocket } from "./useWebSockets";


export const useChat = () => {
    const { chatMessages, setChatMessages, messagesNoRead, setMessagesNoRead, messagesNoReadLength, setMessagesNoReadLength} = useGlobalContext();
    const { messages, lastMessage } = useWebSocket()
    const { getProfileId, getTypeRole } = useProfile()
    const userId = getProfileId();
    const profile = getTypeRole();
    const isAdminSideProfile = profile === "resto" || profile === "owner";
    const chatProfile = isAdminSideProfile ? "resto" : profile;

    const getHostMessage = async () => {
        const res = await getMessageHost();
        setChatMessages(res);
        processNotificationMessage(res)
        return res
    }

    const refreshBeforeSend = () => {
        if (!isAdminSideProfile) {
            getHostMessage();
        }
    }

    const sendAll = async (message, users = [], rawMessage = null, extraPayload = {}) => {
        console.log("[useChat] sendAll request", {
            profile,
            chatProfile,
            message,
            users,
            rawMessage: rawMessage || message,
            extraPayload,
        });
        const res = await sendMessageChat({
            profile: chatProfile,
            message,
            users,
            type: "ALL",
            rawMessage: rawMessage || message,
            ...extraPayload,
        });
        console.log("[useChat] sendAll response", res);

        refreshBeforeSend();
    }

    const sendSingleMessage = async(message, users = [], rawMessage = null, extraPayload = {}) => {
        console.log("[useChat] sendSingleMessage request", {
            profile,
            chatProfile,
            message,
            users,
            rawMessage: rawMessage || message,
            extraPayload,
        });
        const res = await sendMessageChat({
            profile: chatProfile,
            message,
            users,
            type: "SINGLE",
            rawMessage: rawMessage || message,
            ...extraPayload,
        });
        console.log("[useChat] sendSingleMessage response", res);

        refreshBeforeSend();
    }

    const sendGlobalMessage = async(message, users = [], rawMessage = null) => {
        const res = await sendGlobalMessageChat({
            message,
            users,
            type: "SINGLE",
            rawMessage: rawMessage || message
        });

        refreshBeforeSend();
    }


    const markReadMessages = async () => {
        let markMessages = 0;
        for (const e of messagesNoRead || []) {
            await markMessage(e._id);
            markMessages++
        }

        if (markMessages > 0) {
            refreshBeforeSend();
        }
    }

    const processNotificationMessage = (messages) => {
        try {
            let noRead = noReadMessages(messages, userId);
            setMessagesNoRead(noRead);
            setMessagesNoReadLength(noRead.length)
        } catch (error) {
            // Error al procesar mensajes - se ignora
        }
    }

    const noReadMessages = (mensajes = []) => {
        return (mensajes || []).filter(msg => {
            const { readBy, mentionedUserIds } = msg;
            const enviadoAlUsuario = (mentionedUserIds || []).some(u => u._id === userId);
            const noLeido = !(readBy || []).some(r => r === userId || (r._id && r._id === userId));
            return enviadoAlUsuario && noLeido;
        });
    }

    return {
        chatMessages,
        messages,
        lastMessage,
        messagesNoReadLength,
        sendAll,
        sendSingleMessage,
        getHostMessage,
        refreshBeforeSend,
        markReadMessages,
        sendGlobalMessage
    }
}
